export const ENVIRONMENT_HEADER = 'x-mapp-environment';
/**
 * HTTP method tunnelling.
 * The Akamai edge in front of the deployed app answers PATCH / PUT / DELETE with a
 * 501 before the request reaches the API (only GET, HEAD, OPTIONS, POST pass).
 * The web client therefore sends those methods as POST plus this header, and the
 * API's `methodOverride` middleware restores the intended method.
 */
export const METHOD_OVERRIDE_HEADER = 'x-http-method-override';
/**
 * Query-string fallback for the same override (`?_method=DELETE`). CloudFront only forwards an
 * allow-list of headers to the API origin but always forwards the query string, so the client
 * sends both and the API honours either.
 */
export const METHOD_OVERRIDE_QUERY_PARAM = '_method';
export const TUNNELLED_METHODS = ['PATCH', 'PUT', 'DELETE'];
